import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';

// LAYOUT COMPONENTS
import Navbar from '../components/Layout/Navbar'
import FilterBar from '../components/topSales/FilterBar'
import FullPageLoader from '../components/Layout/FullPageLoader';
import Empty from '../components/Layout/Empty';

// COMPONENTS
import CompletedSalesTable from '../components/totalSales/CompletedSalesTable';

// DATA
import agentComponent from '../businesses/agent'
import TopRankingSalesCommissionTable from '../components/totalSales/TopRankingSalesCommissionTable';
import SalesDateListingTable from '../components/totalSales/SalesDateListingTable';
import PVDateListingTable from '../components/totalSales/PVDateListingTable';

const TotalSalesPage = () => {
  const agentID = useSelector(state => state.viewFromAgentId);
  const tableContainer = useRef(null)

  const [loading, setLoading] = useState(false)
  const [isFetching, setIsFetching] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [listedBy, setListedBy] = useState('Branch')

  const [entities, setEntities] = useState(null)
  const [selectedEntity, setSelectedEntity] = useState(null)
  const [selectedAgentSales, setSelectedAgentSales] = useState(null)
  const [selectedAgentPV, setSelectedAgentPV] = useState(null)

  const handleFilter = (data) => {
    const filterData = { ...data }
    filterData.StartDate = data.StartDate.toISOString()
    filterData.EndDate = data.EndDate.toISOString()
    filterData.PVStartDate = data.PVStartDate.toISOString()
    filterData.PVEndDate = data.PVEndDate.toISOString()

    setListedBy(filterData.LiveListBy)
    setEntities(null)
    setSelectedEntity(null)
    setSelectedAgentSales(null)
    setSelectedAgentPV(null)

    // RUN THE FILTERING WITH THE filterData
    setFilterData(filterData)
    setIsFetching(!isFetching)
  }

  const selectEntity = (entity) => {
    setSelectedEntity(null)
    setSelectedAgentSales(null)
    setSelectedAgentPV(null)

    if (agentID) {
      (async () => {
        setLoading(true)
        filterData.BranchID = entity.BranchID
        filterData.BranchName = entity.BranchName
        const agentSalesCommissionPayoutListingByDate = await agentComponent.getAgentSalesCommissionPayoutListingByDate(agentID, filterData)
        if (agentSalesCommissionPayoutListingByDate) {
          setSelectedEntity(agentSalesCommissionPayoutListingByDate)
          setLoading(false)
        } else {
          setLoading(false)
        }
      })()
    }
  }

  const selectAgent = (agent) => {
    const agentID = agent.CommissionPayToUserObjectID
    setSelectedAgentSales(null)
    setSelectedAgentPV(null)

    if (agentID) {
      (async () => {
        setLoading(true)
        const agentCompletedSalesListingByDate = await agentComponent.getAgentCompletedSalesListingByDate(agentID, filterData)
        if (agentCompletedSalesListingByDate) {
          setSelectedAgentSales(agentCompletedSalesListingByDate?.commissionCollection)
          setSelectedAgentPV(agentCompletedSalesListingByDate?.payoutCollection)
          setLoading(false)
        } else {
          setLoading(false)
        }
      })()
    }
  }

  useEffect(() => {
    if (agentID && filterData) {
      (async () => {
        setLoading(true)
        const totalSalesCommissionPayoutByDate = await agentComponent.getTotalSalesCommissionPayoutByDate(agentID, filterData)

        if (totalSalesCommissionPayoutByDate.length > 0) {
          setEntities(totalSalesCommissionPayoutByDate)
          setLoading(false)
        } else {
          setLoading(false)
        }
      })()
    }
  }, [isFetching])

  useEffect(() => {
    if (selectedAgentSales || selectedAgentPV) {
      tableContainer.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [selectedAgentSales, selectedAgentPV])


  return (
    <div className='layout totalsales'>
      <Navbar title='Completed Sales Commission' />
      <FilterBar onHandleFilter={ handleFilter } />

      <div className='content-wrapper'>
        <FullPageLoader loading={ loading } />

        <div className='scrollable'>
          <div className='content'>
            {
              entities ?
              <>
                <div className='table-container'>
                  <div className='top'>
                    <div className='section'>
                      {
                        entities &&
                        <CompletedSalesTable
                          entities={ entities }
                          filterData={ filterData }
                          handleClick={ selectEntity }
                        />
                      }
                    </div>

                    <div className='section'>
                      {
                        selectedEntity &&
                        <TopRankingSalesCommissionTable
                          selectedEntity={ selectedEntity }
                          filterData={ filterData }
                          handleClick={ selectAgent }
                        />
                      }
                    </div>
                  </div>

                  <div ref={ tableContainer } className='bottom'>
                    <div className='section'>
                      {
                        selectedAgentSales &&
                        <SalesDateListingTable
                          selectedEntity={ selectedEntity }
                          selectedAgent={ selectedAgentSales }
                          filterData={ filterData }
                        />
                      }
                    </div>

                    <div className='section'>
                      {
                        selectedAgentPV &&
                        <PVDateListingTable
                          selectedEntity={ selectedEntity }
                          selectedAgent={ selectedAgentPV }
                          filterData={ filterData }
                        />
                      }
                    </div>
                  </div>
                </div>
              </> :
              <>
                <Empty />
              </>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default TotalSalesPage